"use client";
import type { ReactElement } from "react";
import { getFontFamily } from "@/theme/typography";
import { AXIS_HEIGHT } from "./gantt-constants";
import type { GanttLayout } from "./gantt-types";
const AXIS_EDGE_LABEL_PADDING = 72;
const AXIS_LABEL_OFFSET_X = 4;
export interface GanttGridLayerProps {
    ganttIdPrefix: string;
    layout: GanttLayout;
}
export function GanttGridLayer({ ganttIdPrefix, layout, }: GanttGridLayerProps): ReactElement {
    return (<>
      {layout.gridLines.map((line) => {
            const isNearTimelineEnd = line.x > layout.timelineWidth - AXIS_EDGE_LABEL_PADDING;
            const gridLineIdentity = `x-${line.x}`;
            return (<g key={`${ganttIdPrefix}-grid-${line.x}`}>
            <line x1={line.x} y1={AXIS_HEIGHT} x2={line.x} y2={layout.chartHeight} stroke="rgba(255,255,255,0.03)" strokeDasharray="3 4" strokeWidth={1}/>
            <line x1={line.x} y1={AXIS_HEIGHT - 7} x2={line.x} y2={AXIS_HEIGHT - 3} stroke="rgba(255,255,255,0.35)" strokeWidth={1}/>
            <text x={isNearTimelineEnd
                    ? line.x - AXIS_LABEL_OFFSET_X
                    : line.x + AXIS_LABEL_OFFSET_X} y={AXIS_HEIGHT - 12} fill="rgba(255,255,255,0.62)" fontFamily={getFontFamily()} fontSize="11" fontWeight="600" textAnchor={isNearTimelineEnd ? "end" : "start"}>
              {line.label}
            </text>
          </g>);
        })}
    </>);
}
